// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function usedActionFromStr(action) {
  return Belt_Option.mapWithDefault(action, "other", (function (x) {
                var match = x.toLowerCase();
                switch (match) {
                  case "budget" :
                      return "budget";
                  case "perf" :
                      return "perf";
                  case "repr" :
                      return "repr";
                  case "stoc" :
                      return "stoc";
                  default:
                    return "nonfleet";
                }
              }));
}

function derogateSave_encode(v) {
  return Js_dict.fromArray([
              [
                "derogateId",
                Decco.optionToJson(Decco.stringToJson, v.derogateId)
              ],
              [
                "actionId",
                Decco.stringToJson(v.actionId)
              ],
              [
                "negative",
                Decco.boolToJson(v.negative)
              ],
              [
                "derogateLabel",
                Decco.stringToJson(v.derogateLabel)
              ],
              [
                "amount",
                Decco.floatToJson(v.amount)
              ],
              [
                "validation",
                Decco.optionToJson(Decco.stringToJson, v.validation)
              ],
              [
                "comment",
                Decco.optionToJson(Decco.stringToJson, v.comment)
              ],
              [
                "orderType",
                Decco.optionToJson(Decco.stringToJson, v.orderType)
              ]
            ]);
}

function derogateSave_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var derogateId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogateId"), null));
  if (derogateId.TAG === /* Ok */0) {
    var actionId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionId"), null));
    if (actionId.TAG === /* Ok */0) {
      var negative = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "negative"), null));
      if (negative.TAG === /* Ok */0) {
        var derogateLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "derogateLabel"), null));
        if (derogateLabel.TAG === /* Ok */0) {
          var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
          if (amount.TAG === /* Ok */0) {
            var validation = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "validation"), null));
            if (validation.TAG === /* Ok */0) {
              var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
              if (comment.TAG === /* Ok */0) {
                var orderType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderType"), null));
                if (orderType.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            derogateId: derogateId._0,
                            actionId: actionId._0,
                            negative: negative._0,
                            derogateLabel: derogateLabel._0,
                            amount: amount._0,
                            validation: validation._0,
                            comment: comment._0,
                            orderType: orderType._0
                          }
                        };
                }
                var e = orderType._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".orderType" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = comment._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".comment" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = validation._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".validation" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = amount._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".amount" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = derogateLabel._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".derogateLabel" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = negative._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".negative" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = actionId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actionId" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = derogateId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".derogateId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

var DeroSave = {
  derogateSave_encode: derogateSave_encode,
  derogateSave_decode: derogateSave_decode
};

var maxAmount = 20000.0;

export {
  usedActionFromStr ,
  maxAmount ,
  DeroSave ,
}
/* No side effect */
